import { client } from '../client';
import { RxPayload } from './types/ICase';

export const getProviderRx = async (): Promise<RxPayload> => {
  const { data } = await client.get(`/provider/icore/provider_rx`);

  return data;
};
